// extracted by mini-css-extract-plugin
export var btns = "index-module--btns--QoWRj";
export var content = "index-module--content--VtRg2";
export var descItem = "index-module--descItem--kmIOB";
export var descItemDesc = "index-module--descItemDesc--V-WRO";
export var descItemTitle = "index-module--descItemTitle--PUNwt";
export var img = "index-module--img--Kh588";
export var imgDescMbWrapper = "index-module--imgDescMbWrapper--3D4EQ";
export var imgDescWrapper = "index-module--imgDescWrapper--svKKd";